import { render, staticRenderFns } from "./CampaignViewPage.vue?vue&type=template&id=585f92f9&scoped=true"
import script from "./CampaignViewPage.vue?vue&type=script&lang=js"
export * from "./CampaignViewPage.vue?vue&type=script&lang=js"
import style0 from "./CampaignViewPage.vue?vue&type=style&index=0&id=585f92f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f92f9",
  null
  
)

export default component.exports